import { z } from 'zod';
import { zLinklyResponseType } from '../enums';

/**
 * Linkly API response schema - stores responses from Linkly API callbacks
 */
export const linklyResponseSchema = z.object({
  /**
   * A Linkly session can have multiple responses.
   */
  sessionUuid: z.string(),

  /**
   * Type of response received from Linkly
   */
  responseType: zLinklyResponseType,

  /**
   * Raw response from Linkly API.
   * Stored as-is for debugging and auditing purposes.
   */
  rawData: z.any().optional(),

  /**
   * Parsed and validated response data.
   * Will be null if parsing fails - check parseError for details.
   */
  parsedData: z.any().nullable().default(null),
  parseError: z.string().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type LinklyResponse = z.output<typeof linklyResponseSchema>;

export const linklyResponseStrictSchema = linklyResponseSchema.safeExtend({
  sessionUuid: z.guid(),
});

export const linklyResponseCvxSchema = linklyResponseSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type LinklyResponseCvx = z.output<typeof linklyResponseCvxSchema>;
